export default {
  setTitle(state, val) {
    state.pageTitle = val;
    document.title = val;
  },
  setLogin(state, val){
    state.isLogin = val
  },
  setBgc(state, val){
    state.bgc = val
  },
  setPgT(state, val){
    state.pageType = val
  },
  setVouchersState(state, val){
    state.vouchersState = val
  },
  setStoreInfo(state,val){
    state.storeInfo = val
  },
  selectStoreShow(state,val){
    state.selectStore = val
  },
	setGift(state,val){
	  state.gift = val
	},
	setPath(state,val){
	  state.setPath = val
	}
}



// WEBPACK FOOTER //
// ./src/store/mutations.js